import React from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { MEET_LINKS } from '../../constants/meetLinks';
import './Salas.css';

/**
 * Página de Salas Virtuales - Colegio Bertolt Brecht
 * Muestra los enlaces de Google Meet organizados por nivel y grado
 */
const Salas = () => {
    const handleJoin = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="salas">
            <PageHeader
                title="Salas Virtuales"
                subtitle="Accede a tu clase en línea a través de Google Meet. Selecciona tu nivel y grado para unirte."
            />

            <div className="container">
                <div className="salas__intro animate-fade-in">
                    <div className="salas__intro-icon">💻</div>
                    <p>
                        Haz clic en el botón correspondiente a tu grado para ingresar directamente
                        a la sala virtual de Google Meet. Asegúrate de tener tu cámara y micrófono
                        listos antes de unirte.
                    </p>
                </div>

                <div className="salas__niveles">
                    {MEET_LINKS.map((nivel) => (
                        <section
                            key={nivel.nivel}
                            className={`salas__nivel salas__nivel--${nivel.color} animate-slide-up`}
                        >
                            <div className="salas__nivel-header">
                                <span className="salas__nivel-icon">{nivel.icon}</span>
                                <h2 className="salas__nivel-title">{nivel.nivel}</h2>
                                <span className="salas__nivel-badge">
                                    {nivel.grados.length} grados
                                </span>
                            </div>

                            <div className="salas__grados">
                                {nivel.grados.map((grado) => (
                                    <div key={grado.grado} className="salas__grado-card">
                                        <div className="salas__grado-info">
                                            <span className="salas__grado-numero">{grado.grado}</span>
                                            <span className="salas__grado-label">{grado.label}</span>
                                        </div>
                                        <button
                                            className="salas__join-btn"
                                            onClick={() => handleJoin(grado.url)}
                                            aria-label={`Unirse a la sala de ${grado.label}`}
                                        >
                                            <span className="salas__join-icon">📹</span>
                                            Unirse
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </section>
                    ))}
                </div>

                <div className="salas__tips animate-fade-in">
                    <h3 className="salas__tips-title">Recomendaciones para la clase virtual</h3>
                    <div className="salas__tips-grid">
                        <div className="salas__tip-item">
                            <span className="salas__tip-icon">🎧</span>
                            <p>Usa auriculares para evitar el eco y mejorar la calidad del audio.</p>
                        </div>
                        <div className="salas__tip-item">
                            <span className="salas__tip-icon">💡</span>
                            <p>Busca un lugar bien iluminado y con el mínimo de ruido posible.</p>
                        </div>
                        <div className="salas__tip-item">
                            <span className="salas__tip-icon">⏰</span>
                            <p>Ingresa con 5 minutos de anticipación para verificar tu conexión.</p>
                        </div>
                        <div className="salas__tip-item">
                            <span className="salas__tip-icon">📱</span>
                            <p>Puedes acceder desde tu celular, tablet o computadora.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Salas;
